<template>
  <div>
    <HeaderNoAccess></HeaderNoAccess>
    <div class="d-flex justify-center login-recover-window" style="margin: 10vh auto;">
      <v-card v-if="!userAcceptAccountLinking" class="elevation-12" style=" width: 500px;">
        <v-card-title class="d-flex justify-center align-center" style="flex-direction: column;">
          <span style="font-size: larger;">Link Microsoft to Service-Me account</span>
        </v-card-title>
        <v-card-subtitle>
          <span style="text-wrap: wrap;">Press "Continue" to start the linking process.</span>
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-text-field disabled v-model="email" label="Email" name="email" type="text" ref="emailInputField" required
              :rules="userCredentialRules" class="text-field-disabled-opacity-override"></v-text-field>
          </v-container>
          <div class="pa-4">
            <div class="d-flex" style="flex-direction: column; justify-content: space-between; gap: 12px;">
              <v-btn @click="userAcceptAccountLinking = true" block class="login-button">
                <div style="display: flex; align-items: center; gap: 8px;">
                  Continue
                </div>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card v-if="userAcceptAccountLinking && !serviceMeUserAuthenticated" class="elevation-12" style=" width: 500px;"
        @keydown.enter="$refs.userCredentialsForm.validate().then((validationResult) => { validationResult.valid ? authenticateServiceMeUser() : console.error('Email and Password validation failed.') })">
        <v-card-title class="d-flex justify-center align-center" style="flex-direction: column;">
          <span style="font-size: larger;">Sign-in</span>
        </v-card-title>
        <v-card-subtitle>
          <span style="text-wrap: wrap;">Sign-in to your Service-Me account to validate the account linking.</span>
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-form validate-on="submit" ref="userCredentialsForm" @submit.prevent>
              <v-text-field disabled v-model="email" label="Email" name="email" type="text" ref="emailInputField"
                required :rules="userCredentialRules" class="text-field-disabled-opacity-override"></v-text-field>
              <v-spacer></v-spacer>
              <v-text-field v-model="password" id="password" label="Password*" name="password" type="password" required
                :rules="userCredentialRules" ref="passwordInputField"></v-text-field>
            </v-form>
          </v-container>
          <div class="pa-4">
            <div class="d-flex" style="flex-direction: column; justify-content: space-between; gap: 12px;">
              <v-btn type="submit"
                @click="$refs.userCredentialsForm.validate().then((validationResult) => { validationResult.valid ? authenticateServiceMeUser() : console.error('Email and Password validation failed.') })"
                block class="login-button">
                Continue
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card v-if="serviceMeUserAuthenticated" class="elevation-12" style=" width: 500px;"
        @keydown.enter="linkAccounts()">
        <v-card-title class="d-flex justify-center align-center" style="flex-direction: column;">
          <span style="font-size: larger;">Sign-in success!</span>
        </v-card-title>
        <v-card-subtitle>
          <span style="text-wrap: wrap;">Press "Continue" to link the Service-Me account to your microsoft
            account.</span>
        </v-card-subtitle>
        <v-card-text>
          <div class="pa-4">
            <div class="d-flex" style="flex-direction: column; justify-content: space-between; gap: 12px;">
              <v-btn type="submit" @click="linkAccounts()" block class="login-button">
                Continue
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/plugins/backendAPI'
import { mapGetters } from 'vuex';
import HeaderNoAccess from '../../../components/HeaderNoAccess.vue';

export default {
  components: {
    HeaderNoAccess
  },
  data() {
    return {
      userAcceptAccountLinking: false,
      serviceMeUserAuthenticated: false,

      email: this.$route.query["email"],
      password: null,

      userCredentialRules: [
        v => !!v || "Field is required"
      ]
    }
  },
  async created() {
  },
  async mounted() {
    this.$store.dispatch("setLoading", false)
    await this.$root.$ConfirmDialog.open('A Service-Me account was found.'
      , 'Link your microsoft account to the Service-Me account or have your admin delete the account.', { color: 'green', width: 400 })
  },
  computed: {
    ...mapGetters(["msalInstance"])
  },
  methods: {
    triggerLoginByEnter(e) {
      if (e.keyCode === 13) {
        this.registerAccount()
      }
    },
    async authenticateServiceMeUser() {
      this.$store.dispatch("setLoading", true)
      await HTTP.post("/auth/sign-in/jwt", { email: this.email, password: encodeURIComponent(this.password) }).then((response) => {
        this.bearerToken = response.data.bearer
        this.serviceMeUserAuthenticated = true
        this.$store.dispatch("setLoading", false)
      }).catch((e) => {
        if (e.response.status == 400) {
          this.$store.dispatch('showError', `Sign-in failed: ${e.response.data}`)
        } else {
          this.$store.dispatch('showError', 'Sign-in failed: Wrong email or password!')
        }
        this.$store.dispatch('saveUserSSOAuthMethod', null);
        this.$store.dispatch('deleteAuthorization')
        this.password = ''
        this.$store.dispatch("setLoading", false)
      })
    },
    async linkAccounts() {
      this.$store.dispatch("setLoading", true)
      delete HTTP.defaults.headers.common['Authorization']
      try {
        if (this.$route.query["auth-method"] === "SAML") {
          this.$store.dispatch('saveUserSSOAuthMethod', "SAML");
          window.location.href = `${process.env.VUE_APP_APIURL}/auth/link-account/saml?entra-tenant-id=${this.$route.query["entra-tenant-id"]}&organization-id=${this.$route.query["organization-id"]}&token=${this.bearerToken}&email=${this.$route.query["email"]}`
        } else if (this.$route.query["auth-method"] === "OIDC") {
          this.$store.dispatch('saveUserSSOAuthMethod', "OIDC");
          const account = this.msalInstance.getAllAccounts()[0];
          const request = {
            account: account,
            scopes: [
              "api://ac5224de-b904-41c0-8e19-bd7f3abdd9b6/Data.Read",
              "api://ac5224de-b904-41c0-8e19-bd7f3abdd9b6/Data.ReadWrite",
            ],
          };
          const msalResponse = await this.msalInstance.acquireTokenSilent(request)
          if (msalResponse.idTokenClaims.groups === null) {
            throw new Error("Microsoft authentication failed: Your account has not yet been activated.")
          }
          await HTTP.post(`/auth/link-account/oidc?entra-tenant-id=${this.$route.query["entra-tenant-id"]}&organization-id=${this.$route.query["organization-id"]}&token=${this.bearerToken}`, msalResponse.idTokenClaims.groups)
            .then(() => {
              this.$router.push({ name: "AuthCallback", query: { "auth-method": "OIDC", "token": HTTP.defaults.headers.common['Authorization'].substring("Bearer ".length) } })
            })
            .catch(async (e) => {
              this.$router.push({ name: "AdminSignIn", query: { "error": `Account registration with OIDC failed: ${e.response.data}` } })
            })
        }
      } catch (error) {
        this.$store.dispatch('showError', error)
        this.$store.dispatch('saveUserSSOAuthMethod', null);
        this.$store.dispatch('deleteAuthorization')
        this.password = ''
        this.$store.dispatch("setLoading", false)
      }
    }
  },
}

</script>
